import * as RequestTypes from "Application/RequestTypes";

type EndPointConfig = {
  url: string;
  method: "GET" | "POST" | "PUT" | "DELETE";
};

const EndPoints: Record<string, EndPointConfig> = {
  // ---------------------- SECURITY ------------------------
  [RequestTypes.TOUCH]: {
    url: "/touch",
    method: "GET",
  },
  [RequestTypes.LOGIN]: {
    url: "/login",
    method: "POST",
  },
  [RequestTypes.LOGOUT]: {
    url: "/logout",
    method: "POST",
  },
  [RequestTypes.MY_RIGHTS]: {
    url: "/myRights",
    method: "GET",
  },
  [RequestTypes.IMPERSONATE_USER]: {
    url: "/impersonate/:id",
    method: "POST",
  },

  // ---------------------- REGISTER ------------------------
  [RequestTypes.REGISTER_REQUEST]: {
    url: "/register/create",
    method: "POST",
  },
  [RequestTypes.RESET_PASSWORD]: {
    url: "/register/reset-password",
    method: "POST",
  },
  [RequestTypes.FORGOT_PASSWORD]: {
    url: "/register/request-reset-password",
    method: "POST",
  },
  [RequestTypes.REQUEST_RESET_PASSWORD]: {
    url: "/register/request-reset-password",
    method: "POST",
  },
  [RequestTypes.SIGN_USER_CONTRACT]: {
    url: "/contract/sign",
    method: "POST",
  },

  // ---------------------- USER ------------------------
  [RequestTypes.MY_DATA]: {
    url: "/users/my",
    method: "GET",
  },
  [RequestTypes.USER_DATA]: {
    url: "/users/:id",
    method: "GET",
  },
  [RequestTypes.USER_SEARCH]: {
    url: "/users",
    method: "GET",
  },
  [RequestTypes.UPDATE_USER_DATA]: {
    url: "/users/update/:id",
    method: "PUT",
  },
  [RequestTypes.USER_CONTRACT]: {
    url: "/contract/:id",
    method: "GET",
  },
  [RequestTypes.CURRENT_USER_CONTRACT]: {
    url: "/contract",
    method: "GET",
  },

  // ---------------------- DEBTOR ------------------------
  [RequestTypes.DEBTOR_SEARCH]: {
    url: "/debtor",
    method: "GET",
  },
  [RequestTypes.DEBTOR_GET]: {
    url: "/debtor/:id",
    method: "GET",
  },
  [RequestTypes.DEBTOR_CREATE]: {
    url: "/debtor/create",
    method: "POST",
  },
  [RequestTypes.DEBTOR_UPDATE]: {
    url: "/debtor/:id",
    method: "PUT",
  },

  // ---------------------- INTERNAL ------------------------
  [RequestTypes.DELETE_INTERNAL_USER]: {
    url: "/internal/:id/deleteUser",
    method: "DELETE",
  },
  [RequestTypes.CREATE_INTERNAL_USER]: {
    url: "/internal/createUser",
    method: "POST",
  },
  [RequestTypes.INTERNAL_USER_VALIDATION]: {
    url: "/internal/validateCreditor/:id",
    method: "POST",
  },

  // ---------------------- PAYMENT PLAN ------------------------
  [RequestTypes.PAYMENT_PLAN_SEARCH]: {
    url: "/payment-plan",
    method: "GET",
  },
  [RequestTypes.PAYMENT_PLAN_DETAILS]: {
    url: "/payment-plan/:id",
    method: "GET",
  },
  [RequestTypes.CREATE_PAYMENT_PLAN]: {
    url: "/payment-plan/create",
    method: "POST",
  },
  [RequestTypes.PAYMENT_PLAN_CONTRACT]: {
    url: "/payment-plan/:id/contract",
    method: "GET",
  },
  [RequestTypes.SIGN_PAYMENT_PLAN_CONTRACT]: {
    url: "/payment-plan/sign",
    method: "POST",
  },
  [RequestTypes.PAYMENT_PLAN_SEND_TO_DEBTOR]: {
    url: "/payment-plan/:id/public-signature",
    method: "POST",
  },
  [RequestTypes.PAYMENT_PLAN_SECURED_NEXT_SESSION]: {
    url: "/payment-plan/:id/secured-next-session",
    method: "POST",
  },
  [RequestTypes.GET_PAYMENT_PROVIDER_REQUEST]: {
    url: "/payment-service/setup-payment/:id",
    method: "POST",
  },

  // ---------------------- PAYMENT PLAN PUBLIC ------------------------
  [RequestTypes.PAYMENT_PLAN_DETAILS_PUBLIC]: {
    url: "/payment-plan-public/:token",
    method: "GET",
  },
  [RequestTypes.PAYMENT_PLAN_CONTRACT_PUBLIC]: {
    url: "/payment-plan-public/:token/contract",
    method: "GET",
  },
  [RequestTypes.SIGN_PAYMENT_PLAN_CONTRACT_PUBLIC]: {
    url: "/payment-plan-public/sign",
    method: "POST",
  },
  [RequestTypes.GET_PAYMENT_PROVIDER_REQUEST_PUBLIC]: {
    url: "/payment-service/setup-payment-public/:token",
    method: "POST",
  },
  // ---------------------- PAYMENT ------------------------
  [RequestTypes.PAYMENT_SEARCH]: {
    url: "/payment",
    method: "GET",
  },
  [RequestTypes.PAYMENT_DETAILS]: {
    url: "/payment/:id",
    method: "GET",
  },
  [RequestTypes.PAYMENT_FILE]: {
    url: "/payment/:id/paymentFile",
    method: "GET",
  },
  [RequestTypes.PAYMENT_MARK_AS_PAYED]: {
    url: "/payment/:id/executed-payment",
    method: "POST",
  },
  [RequestTypes.CREDITOR_PAYMENT_SEARCH]: {
    url: "/creditor-payment",
    method: "GET",
  },
  [RequestTypes.CREDITOR_PAYMENT_DETAILS]: {
    url: "/creditor-payment/:id",
    method: "GET",
  },
};

function getRequestConfig(endPointType: string) {
  if (endPointType in EndPoints) {
    return EndPoints[endPointType];
  }
  throw new Error("Api endpoint not provided");
}

export default getRequestConfig;
